import axios from 'axios'
import toastr from 'toastr'

export default {
  namespaced: true,

  state : {
    excursionTypes : []
  },

  getters : {
    //all orders for authenticated user:
    getExcursionTypes : state => state.excursionTypes,
    //get order based on unique param uuid:
   


  },

  mutations : {
    SET_EXCURSION_TYPES : (state, payload) => {
        state.excursionTypes = payload.excursionTypes
    },
  },

  actions: {
    // TYPICAL ACTION BLUEPRINT:
    async getExcurionTypes (context) {
      axios.post('/booker/get-types')
        .then(function ({data}) {
            context.commit('SET_EXCURSION_TYPES', {
              excursionTypes : data.excursionTypes
            })
        })
        .catch(function (error) {
          
        })
      },

  }
}


